import { createTheme } from "@mui/material"
import { renderMultiSectionDigitalClockTimeView } from "@mui/x-date-pickers"
import type { MultiSectionDigitalClockProps, TimeView, TimeViewRendererProps } from "@mui/x-date-pickers"
import type {} from "@mui/x-date-pickers/themeAugmentation"

import { TailwindPalette, tailwindPalette } from "./tailwindPalette"

type TimeViewListProps = Omit<
    TimeViewRendererProps<TimeView, MultiSectionDigitalClockProps<unknown>>,
    "onFocusedViewChange"
> & {
    onFocusedViewChange?: (view: TimeView, hasFocus: boolean) => void
}

// the mobile picker has no AM/PM view, so the list's meridiem column must not reach it
function renderTimeViewList({ onViewChange, onFocusedViewChange, ...props }: TimeViewListProps) {
    return renderMultiSectionDigitalClockTimeView({
        ...props,
        onViewChange: (view) => {
            if (view !== "meridiem") onViewChange?.(view)
        },
        onFocusedViewChange: (view, hasFocus) => {
            if (view !== "meridiem") onFocusedViewChange?.(view, hasFocus)
        },
    })
}

declare module "@mui/material/styles" {
    interface PaletteOptions {
        tailwind: TailwindPalette
    }
    interface Palette {
        tailwind: TailwindPalette
    }
}

export const theme = createTheme({
    typography: {
        subtitle1: {
            fontWeight: 500
        }
    },
    components: {
        MuiStack: {
            defaultProps: {
                useFlexGap: true,
            },
        },
        // touch devices get the same hour/minute lists as desktop instead of MUI's clock face
        MuiMobileTimePicker: {
            defaultProps: {
                viewRenderers: {
                    hours: renderTimeViewList,
                    minutes: renderTimeViewList,
                    seconds: renderTimeViewList,
                },
            },
        },
        MuiMultiSectionDigitalClock: {
            styleOverrides: {
                // the mobile dialog is far wider than the fixed-width list columns
                root: {
                    "@media (pointer: coarse)": {
                        justifyContent: "center",
                    },
                },
            },
        },
    },
    palette: {
        tailwind: tailwindPalette,
    }
})
